var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackSquare = function SvgBackSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 45,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#back-square_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    filter: "url(#back-square_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#back-square_svg__c)",
    fillRule: "evenodd",
    d: "M34.721 37.5c-2.41 1.75-5.846 1.75-12.721 1.75-6.874 0-10.312 0-12.721-1.75A9.2 9.2 0 0 1 7.25 35.47C5.5 33.061 5.5 29.625 5.5 22.75c0-6.874 0-10.312 1.75-12.721A9.2 9.2 0 0 1 9.28 8C11.689 6.25 15.126 6.25 22 6.25c6.875 0 10.312 0 12.721 1.75a9.2 9.2 0 0 1 2.028 2.029C38.5 12.439 38.5 15.876 38.5 22.75c0 6.875 0 10.312-1.75 12.721A9.2 9.2 0 0 1 34.72 37.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#back-square_svg__d)",
    strokeLinecap: "round",
    d: "M34.721 37.5c-2.41 1.75-5.846 1.75-12.721 1.75-6.874 0-10.312 0-12.721-1.75A9.2 9.2 0 0 1 7.25 35.47C5.5 33.061 5.5 29.625 5.5 22.75c0-6.874 0-10.312 1.75-12.721A9.2 9.2 0 0 1 9.28 8C11.689 6.25 15.126 6.25 22 6.25c6.875 0 10.312 0 12.721 1.75a9.2 9.2 0 0 1 2.028 2.029C38.5 12.439 38.5 15.876 38.5 22.75c0 6.875 0 10.312-1.75 12.721A9.2 9.2 0 0 1 34.72 37.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#back-square_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#back-square_svg__f)",
    fillRule: "evenodd",
    d: "M24.699 12.607a1.375 1.375 0 1 1 1.936 1.953l-3.232 3.203c-1.312 1.3-2.212 2.195-2.82 2.953-.592.737-.795 1.21-.85 1.633a3.2 3.2 0 0 0 0 .802c.055.423.258.896.85 1.633.608.758 1.508 1.652 2.82 2.953l3.232 3.203a1.375 1.375 0 0 1-1.936 1.953l-3.29-3.26c-1.24-1.23-2.253-2.233-2.971-3.127-.747-.93-1.288-1.875-1.432-3.008-.063-.497-.063-1 0-1.496.144-1.133.685-2.078 1.432-3.008.718-.894 1.731-1.898 2.97-3.126z",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "back-square_svg__c",
    x1: 38.5,
    x2: 5.517,
    y1: 39.25,
    y2: 6.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "back-square_svg__d",
    x1: 38.5,
    x2: 5.517,
    y1: 39.25,
    y2: 6.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "back-square_svg__f",
    x1: 14.81,
    x2: 37.296,
    y1: 22.572,
    y2: 11.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "back-square_svg__b",
    width: 82,
    height: 82,
    x: -19,
    y: -18.25,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_4275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_1_4275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "back-square_svg__e",
    width: 26.083,
    height: 37.083,
    x: 13.959,
    y: 9.208,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1_4275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "back-square_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .75h44v44H0z"
  })))));
};
export { SvgBackSquare as ReactComponent };